'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticCart = function () {
  function StaticCart(section) {
    var _this = this;

    (0, _classCallCheck3.default)(this, StaticCart);

    this.el = section.el;
    this.ev = new _EventHandler2.default();

    this.cartForm = this.el.querySelector('.cart');
    this.shippingStrings = this.el.querySelector('[data-shipping-calculator-strings]');
    this.shippingContext = {};

    if (this.shippingStrings) {
      this.countryProvinceSelector = new Shopify.CountryProvinceSelector('address_country', 'address_province', {
        hideElement: 'address_province_container'
      });

      try {
        this.shippingContext = JSON.parse(this.shippingStrings.text());
      } catch (error) {
        console.log('No shipping localisations found, unable to continue.');
      }

      if (this.shippingContext == null) {
        return;
      }

      if (this.el.querySelector('[data-cart-item]')) {
        this.shippingCalculator();
      }
    }

    if (document.querySelector('.free_item_promo-wrap') && document.querySelector('.free_item_promo-wrap').firstElementChild) {
      this.freeItems();
    }

    Shopify.onError = function (XMLHttpRequest) {
      return _this.handleErrors(XMLHttpRequest);
    };

    this.el.querySelectorAll('.quantity .field').forEach(function (field) {
      _this.ev.register(field, 'change', _this.updateQuantity.bind(_this));
    });
    this.ev.register(this.el.querySelector('.instructions textarea'), 'change', this.saveNote.bind(this));
    this.ev.register(this.el.querySelector('.get-rates'), 'click', this.calculateShipping.bind(this));
    this.ev.register(this.el.querySelector('#address_zip'), 'keydown', this.calculateShipping.bind(this));
  }

  (0, _createClass3.default)(StaticCart, [{
    key: 'updateQuantity',
    value: function updateQuantity(e) {
      var input = e.currentTarget;
      var quantity = input.value;
      var id = input.dataset.id;
      var url = '/cart/change/' + id + '?quantity=' + quantity;

      window.location = url;
    }
  }, {
    key: 'freeItems',
    value: function freeItems() {
      var _this2 = this;

      var marker = this.el.querySelector('.inline-cart__top-shipping-wrap');
      marker.insertAdjacentElement('afterend', document.querySelector('#shopify-section-static-cart + .free_item_promo-wrap'));

      var freeItemSelect = this.el.querySelector('.free_item_promo-select_label');
      this.ev.register(freeItemSelect, 'click', function () {
        freeItemSelect.parentElement.classList.toggle('hover');
      });

      var freeItems = this.el.querySelectorAll('.free_item_promo-select_item');
      freeItems.forEach(function (freeItem) {
        var freeItemForm = freeItem.querySelector('form');
        _this2.ev.register(freeItemForm, 'submit', function (e) {
          var variantId = freeItemForm.querySelector('[name="id"]');
          if (variantId.value.includes('Select')) {
            e.preventDefault();
            freeItemForm.querySelector('.select-wrapper').classList.add('unselected');
            return;
          }
        });
      });
    }
  }, {
    key: 'saveNote',
    value: function saveNote() {
      var newNote = this.el.querySelector('.instructions textarea').value;

      Shopify.updateCartNote(newNote, function () {});
    }
  }, {
    key: 'shippingCalculator',
    value: function shippingCalculator() {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: this.shippingContext.submitButton,
        submitButtonDisabled: this.shippingContext.submitButtonDisabled,
        customerIsLoggedIn: this.shippingContext.customerIsLoggedIn,
        moneyFormat: this.shippingContext.moneyFormat
      });
    }
  }, {
    key: 'calculateShipping',
    value: function calculateShipping(e) {
      var _this3 = this;

      if (e && e.type === 'keydown') {
        if (e.keyCode === 13) {
          e.preventDefault();
          this.el.querySelector('.wrapper-response').innerHTML = '';
        } else {
          return;
        }
      }

      var shippingAddress = {};
      shippingAddress.zip = this.el.querySelector('.address-zip').value || '';
      shippingAddress.country = this.el.querySelector('.address-country').value || '';
      shippingAddress.province = this.el.querySelector('.address-province').value || '';

      Shopify.getCartShippingRatesForDestination(shippingAddress, function (rates) {
        var address = shippingAddress.zip + ', ' + shippingAddress.province + ', ' + shippingAddress.country;
        if (!shippingAddress.province.length) {
          address = shippingAddress.zip + ', ' + shippingAddress.country;
        }
        if (!shippingAddress.zip.length) {
          address = shippingAddress.province + ', ' + shippingAddress.country;
        }
        if (!shippingAddress.province.length || !shippingAddress.zip.length) {
          address = shippingAddress.country;
        }

        _this3.el.querySelector('.wrapper-response').innerHTML = "<p class='shipping-calculator-response message'></p><ul class='shipping-rates'></ul>";

        var ratesFeedback = _this3.el.querySelector('.shipping-calculator-response');
        if (rates.length > 1) {
          var firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
          var multipleShippingRates = Theme.shippingCalcMultiRates.replace('--address--', address).replace('--number_of_rates--', rates.length).replace('--rate--', '<span class=\'money\'>' + firstRate + '</span>');
          ratesFeedback.innerHTML = multipleShippingRates;
        } else if (rates.length === 1) {
          var oneShippingRate = Theme.shippingCalcOneRate.replace('--address--', address);
          ratesFeedback.innerHTML = oneShippingRate;
        } else {
          ratesFeedback.innerHTML = Theme.shippingCalcNoRates;
        }

        for (var i = 0; i < rates.length; i++) {
          var rate = rates[i];
          var price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          var rateValues = Theme.shippingCalcRateValues.replace('--rate_title--', rate.name).replace('--rate--', '<span class=\'money\'>' + price + '</span>');
          var rateValueEl = document.createElement('li');
          rateValueEl.innerHTML = rateValues;
          _this3.el.querySelector('.shipping-rates').appendChild(rateValueEl);
        }
      });
    }
  }, {
    key: 'handleErrors',
    value: function handleErrors(errors) {
      var errorMessage = JSON.parse(errors.responseText);
      errorMessage = Theme.shippingCalcErrorMessage.replace('--error_message--', errorMessage.zip);
      return this.el.querySelector('.wrapper-response').innerHTML = '<p class=\'message\'>' + errorMessage + '</p>';
    }
  }, {
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.ev.unregisterAll();
    }
  }]);
  return StaticCart;
}();

exports.default = StaticCart;